
import { Vue, Component, Prop } from 'vue-property-decorator';
import { CombinationsConfiguratorFormData } from '@/interfaces/components/combinations/CombinationsConfiguratorFormData';
import { CombinationsOptions } from '@/enums/global/GlobalOptions';
import ChecklistField from '@/models/ChecklistField';

@Component({
    name: 'CombinationsProductDropdowns',
})
export default class CombinationsProductDropdowns extends Vue {
    @Prop({ type: Array, required: true }) private tableHeaderFields!: any[];
    @Prop({ type: Array, required: true }) private productRowsFormData!: CombinationsConfiguratorFormData[];
    @Prop({ type: Array, required: true }) private dropdownChecklistFields!: ChecklistField[];
    @Prop({ type: String, required: true }) private combinationType!: string;
    @Prop({ type: String, required: true }) private guideType!: string;
    @Prop({ type: String, required: true }) private secondGuideType!: string;
    @Prop({ type: Boolean, required: true }) private areFirstTwoWindowsOfSameHeight!: boolean;
    @Prop({ type: Boolean, required: true }) private areLastTwoWindowsOfSameHeight!: boolean;
    @Prop({ type: Boolean, required: true }) private shouldShowAssemblyCode!: boolean;
    @Prop({ type: Object, required: true }) private FilteredCombinationsOptions!: any;
    @Prop({ type: Object, required: true }) private currentConfig!: any;
    @Prop({ type: Boolean, required: true }) private useSlidingScreen!: boolean;
    @Prop({ type: Boolean, required: true }) private useSlidingScreenForCombination!: boolean;

    private getDimensionsText(row: CombinationsConfiguratorFormData): string {
        const width =
            row.formData.find((field) => field.fieldPID === this.FilteredCombinationsOptions.WIDTH_PID)?.fieldValue ||
            '-';
        const height =
            row.formData.find((field) => field.fieldPID === this.FilteredCombinationsOptions.HEIGHT_PID)?.fieldValue ||
            '-';
        return `${width} × ${height}`;
    }

    private getDropdownFields(row: CombinationsConfiguratorFormData) {
        return row.formData
            .map((field) => {
                const headerField = this.tableHeaderFields.find((headerField) => headerField.pid === field.fieldPID);

                if (headerField && headerField.type === 'dropdown' && headerField.active) {
                    return {
                        ...field,
                        options:
                            this.dropdownChecklistFields.find((checklist) => checklist.pId === field.fieldPID)
                                ?.checklistDropdownField?.checklistDropdownOptions || [],
                    };
                }
                return null;
            })
            .filter((field): field is NonNullable<typeof field> => field !== null && field !== undefined);
    }

    private get pogonOptions() {
        return (
            this.dropdownChecklistFields.find(
                (checklist) => checklist.pId === this.FilteredCombinationsOptions.LEFT_GUIDE_PID,
            )?.checklistDropdownField?.checklistDropdownOptions || []
        ).filter((option) => {
            console.log(option);
            if (!this.areFirstTwoWindowsOfSameHeight && option.vId === 'Pregradno') {
                return false;
            }

            return true;
        });
    }

    private get secondPogonOptions() {
        return (
            this.dropdownChecklistFields.find(
                (checklist) => checklist.pId === this.FilteredCombinationsOptions.RIGHT_GUIDE_PID,
            )?.checklistDropdownField?.checklistDropdownOptions || []
        ).filter((option) => {
            if (!this.areLastTwoWindowsOfSameHeight && option.vId === 'Pregradno') {
                return false;
            }

            return true;
        });
    }

    private onDropdownChange(productId: number, fieldPID: string, value: string) {
        this.$emit('updateFormField', { productId, fieldPID, value });
    }

    private onVodilaDropdownChange(value: string, vodilaNumber: number) {
        this.$emit('updateVodilaField', { value, vodilaNumber });
    }

    private updateSlidingScreen(value: boolean) {
        this.$emit('updateSlidingScreen', value);
    }

    private getSystemAndRowIdLabel(row: CombinationsConfiguratorFormData, rowIndex: number): string {
        const system =
            row.formData.find((field) => field.fieldPID === this.FilteredCombinationsOptions.SISTEM_PID)?.fieldValue ||
            '';
        const rowId = row.activeProductFormId + 1; // +1 to make it 1-based index
        return `${system} - ${rowIndex + 1}`; // +1 to make it 1-based index
    }
}
